// @ts-nocheck

export default {
  allowConnectToDB: true,
};
